import { SEARCH_REQUEST_SET_TERM, SEARCH_REQUEST_UPDATE_TIMES, SEARCH_REQUEST_UPDATE_TERMS_AND_POWER_BOOKING_TIMES, } from '../search-request/search-request-actions';
import { LOYALTY_PROGRAM_FILTER_VALUES, } from './loyalty-filter-utils';
import { FILTERS_RESET, FILTERS_UPDATE, FILTER_GET_SESSION, FILTER_SET_SHOW_TOTAL, SEARCH_SET_LOYALTY_PROGRAM, } from './filters-actions';
import { initialReservationTypes } from './filters-utils';
import { initialRatingTypes } from './rating-filter-utils';
import { SPOTS_GET_BULK_TRANSIENT_V2, SPOTS_GET_TRANSIENT_V2, } from 'store/spots/spots-actions-v2';
import { ActionType } from 'redux-promise-middleware';
import { v4 as uuidV4 } from 'uuid';
import { StorageKeys, StorageTypes } from 'common/constants/storageKeys';
import StorageUtils from '@spothero/utils/storage';
import ErrorUtils from 'utils/error-utils';
export const loadPersistedState = (currentAmenities = []) => {
    // Early return if currentAmenities is not an array
    if (!Array.isArray(currentAmenities)) {
        return [];
    }
    // if store doesn't have activeAmenities, reach for storage.  Otherwise get storage and use that.
    if (currentAmenities.length === 0) {
        try {
            const item = StorageUtils.get(StorageKeys.ACTIVE_AMENITIES, StorageTypes.SESSION);
            const thingToReturn = item ? JSON.parse(item) : [];
            return Array.isArray(thingToReturn) ? thingToReturn : [];
        }
        catch (error) {
            ErrorUtils.sendSentryException(error);
            return [];
        }
    }
    return currentAmenities;
};
const persistState = (state) => {
    try {
        const { activeAmenities } = state;
        StorageUtils.set(StorageKeys.ACTIVE_AMENITIES, JSON.stringify(activeAmenities), StorageTypes.SESSION);
    }
    catch (error) {
        ErrorUtils.sendSentryException(error);
    }
    return state;
};
export const initialState = {
    // filterId is used to determine if the filters have changed
    filterId: uuidV4(),
    numActive: 0,
    ratingTypes: { ...initialRatingTypes },
    activeRatingTypes: [],
    amenities: {},
    activeAmenities: loadPersistedState(), // Load persisted activeAmenities
    reservationTypes: { ...initialReservationTypes },
    activeReservationType: 'all',
    viaQuickFilter: false,
    walkingDistanceLimitInMinutes: 0,
    showTotal: false,
    loyaltyProgram: LOYALTY_PROGRAM_FILTER_VALUES.UNSET,
};
export default function filters(state = initialState, { type, payload }) {
    switch (type) {
        case FILTERS_RESET:
        case SEARCH_REQUEST_SET_TERM: {
            const newState = {
                ...initialState,
                activeAmenities: [], // Reset activeAmenities
                filterId: uuidV4(),
            };
            // Clear sessionStorage on reset
            StorageUtils.remove(StorageKeys.ACTIVE_AMENITIES, StorageTypes.SESSION);
            return newState;
        }
        case FILTERS_UPDATE: {
            const newState = {
                ...state,
                ...payload,
                filterId: uuidV4(),
            };
            newState.numActive = newState.activeAmenities.length;
            return persistState(newState);
        }
        // Reset walking distance limit when a new search is triggered
        case `${SPOTS_GET_TRANSIENT_V2}_${ActionType.Pending}`:
        case `${SPOTS_GET_BULK_TRANSIENT_V2}_${ActionType.Pending}`:
        case SEARCH_REQUEST_UPDATE_TERMS_AND_POWER_BOOKING_TIMES:
        case SEARCH_REQUEST_UPDATE_TIMES: {
            return {
                ...state,
                filterId: uuidV4(),
                walkingDistanceLimitInMinutes: 0,
            };
        }
        case FILTER_SET_SHOW_TOTAL: {
            return {
                ...state,
                showTotal: payload,
            };
        }
        case SEARCH_SET_LOYALTY_PROGRAM: {
            return {
                ...state,
                loyaltyProgram: payload,
            };
        }
        case FILTER_GET_SESSION: {
            const { activeAmenities: currentAmenities } = state;
            // Load persisted state for activeAmenities to ensure consistency
            // between sessions or page reloads. This helps maintain user preferences.
            const persistedActiveAmenities = loadPersistedState(currentAmenities);
            const newState = {
                ...state,
                activeAmenities: persistedActiveAmenities,
            };
            newState.numActive = newState.activeAmenities.length;
            return newState;
        }
        default:
            return state;
    }
}
